import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

const useListBulkImports = (params = {}) => {
	const { accessToken } = useTokenStore();

	return useQuery(
		["bulkBookImports", params],
		async () => {
			const instance = await InitApi({ accessToken });
			const response = await instance.get("/publisher/bulk-book-imports", {
				params,
			});
			return response.data?.data;
		},
		{ keepPreviousData: true }
	);
};

export default useListBulkImports;
